import { api_GET, api_PUT,api_POSTFile } from "api/_axios.js";

const dreadministrativo_api =
{
    get: function (grupoeconomico, mesano) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`dreadministrativo/${encodeURIComponent(grupoeconomico)}/${mesano}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    put: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`dreadministrativo`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getCsvTemplateImport: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`dreadministrativo/modeloCsvImport`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    postImportCsv: function (usuarioId,grupoEconomico,formData) {
        const promise = new Promise((resolve, reject) => {
            api_POSTFile(`dreadministrativo/uploadCSVDreAdministrativo/${usuarioId}/${encodeURIComponent(grupoEconomico)}`, formData).then(result => {
                resolve(result)
            });
        });
        return promise;
    }
}

export default dreadministrativo_api
